<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
		{{title}}: {{name}}
	</h4>
</div>
<div id="dataInput" class="m-t-20 m-b-20"></div>
<div class="modal-footer">
	{{#if remoteValue}}
	<button id="js-stop" class="btn btn-white pull-left">{{TR "Fremdwertbezug beenden"}}</button>
	{{/if}}
	{{#if smartTemp}}
	<button id="js-stop" class="btn btn-white pull-left">{{#if isDryRun}}{{TR "Smart Temp-Vorschau beenden"}}{{else}}{{TR "Smart Temp beenden"}}{{/if}}</button>
	{{/if}}
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save">{{action}}</button>
</div>
